import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../icon';

function ElementDragLayer({
  text,
  glyph = 'move',
  glyphSize = 16,
  glyphStrokeWidth = 2,
  className = '',
  ...otherProps
}) {
  const classes = classNames('ws-element-drag-layer', className);

  return (
    <div {...otherProps} className={classes}>
      <Icon glyph={glyph} size={glyphSize} strokeWidth={glyphStrokeWidth} />
      <span className="ws-element-drag-layer__label">{text}</span>
    </div>
  );
}

ElementDragLayer.propTypes = {
  text: PropTypes.string.isRequired,
  glyph: PropTypes.string,
  glyphSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  glyphStrokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

export default ElementDragLayer;
